import { Otp } from "../pages";
import { Login } from "../pages";

export default function route() {
  return [
    {
      path: "/",
      name: "Login",
      key: "/",
      private: false,
      element: <Login />,
    },
    {
      path: "/otp",
      name: "Otp",
      key: "/otp",
      private: false,
      element: <Otp />,
    },
  ];
}
